import { call, put } from 'redux-saga/effects';
import { turnMessageOn } from 'store/app/actions';
import { MessageData } from 'store/app/types';
import { logoutRequest } from 'store/auth/actions';
import { ApiError } from 'store/api/types';
import { MessageStates } from 'containers/MessageBox';
import { checkResponse } from 'store/utils';
import { renderErrorMessage } from 'utils/render-error-message';
import {
  resetReconciliation,
  saveReconciliationReportFailure,
  saveReconciliationReportSuccess,
} from '../actions';
import { saveReconciliationReport, SaveReconciliationReportResponse } from '../api';
import { SaveReconciliationReportRequestAction } from '../types';
import { clearReconciliationRun, loadReconFailure } from 'store/vat/actions';
import i18n from 'i18next';

export function* saveReconciliationReportSaga(
  action: SaveReconciliationReportRequestAction
) {
  try {
    const response: SaveReconciliationReportResponse = yield call(
      saveReconciliationReport,
      action.payload
    );
    const err: ApiError | null = checkResponse(response?.responseMessage);
    if (err) throw err;

    const message: MessageData = {
      title: i18n.t('common.success-exclamation'),
      description:
        response?.responseMessage?.message ||
        i18n.t('organisation.reconciliation-report-saved'),
      type: MessageStates.SUCCESS,
    };

    yield put(turnMessageOn(message));
    yield put(saveReconciliationReportSuccess());
    // Same behaviour as cancel: clear reconciliation UI/data after successful save.
    yield put(resetReconciliation());
    yield put(loadReconFailure());
    yield put(clearReconciliationRun());
  } catch (error: any) {
    const message: MessageData | null = renderErrorMessage(error);
    if (message) {
      yield put(turnMessageOn(message));
    } else {
      yield put(logoutRequest());
    }
    yield put(saveReconciliationReportFailure(error?.message));
  }
}

